import React from 'react';
import PropTypes from 'prop-types';
import styles from './CreateScreenSubmissionButtons.module.scss';

const CreateScreenSubmissionButtons = ({
  handleCheckout,
  handlePreview,
  handleDelete,
  status,
  touched,
}) => {
  return (
    <div className="row">
      <div className={`${styles.buttonContainer} columns large-7 medium-8`}>
        <button
          type="submit"
          className={`button ${touched ? 'button--medium' : 'button--disabled'}`}
          onClick={handleCheckout}
        >
          {status === 'PAID' ? 'Update' : 'Continue to checkout'}
        </button>
        <button
          type="button"
          className="button button--soft analytics t-event-listings-preview"
          onClick={handlePreview}
        >
          {status === 'PAID' ? 'Update & Preview' : 'Preview'}
        </button>
        {status === 'PAID' && (
          <button
            type="button"
            className={`${styles.deleteButton} button button--soft`}
            onClick={handleDelete}
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
};

CreateScreenSubmissionButtons.propTypes = {
  handleCheckout: PropTypes.func.isRequired,
  handlePreview: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  touched: PropTypes.bool.isRequired,
};

export default CreateScreenSubmissionButtons;
